import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';
import './EditPageAddEntity.less'

const EditPageAddEntity = ({
  children,
  entitiesListTitle,
  entityName,
  onAddButton,
  onAddText,
  onAdd,
}) => {
  return (
    <section className="edit-page__add-entity-section">
      <div className="entities-list-section">
        <h4 className="entities-list-title">{entitiesListTitle || `Your ${entityName}s`}</h4>
        <div className="entities-list">
          {children}
        </div>
      </div>
      <div className="add-entity-btn">
        {onAddButton || <ButtonV2 type="button" onClick={onAdd}>{onAddText || `Add A ${entityName}`}</ButtonV2>}
      </div>
    </section>
  )
}

EditPageAddEntity.propTypes = {
  children: PropTypes.node,
  entitiesListTitle: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  entityName: PropTypes.string,
  onAdd: PropTypes.func,
  onAddText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
};

export default EditPageAddEntity;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EditPageCommon/EditPageAddEntity/EditPageAddEntity.jsx